import { TmAuthError } from '@/core/error/transport/auth/TmAuthError'

export class TmAuthAccountSubAccountClosedError extends TmAuthError {}
